const SET_HEADER_SEARCH_BUTTON = 'SET_HEADER_SEARCH_BUTTON';

export default {
	namespaced: true,
	state: {
		hideHeaderSearchMenu: false,
		params: {}
	},
	actions: {
		toggleHeaderSearchMenu({ state, commit }) {
			commit(SET_HEADER_SEARCH_BUTTON, !state.hideHeaderSearchMenu);
		}
	},
	mutations: {
		[SET_HEADER_SEARCH_BUTTON](state, payload) {
			state.hideHeaderSearchMenu = payload;
		}
	}
}



// WEBPACK FOOTER //
// ../source/modules/HEA01-header/HEA01-header.vuex.js